<div class="icd-code-popup">
    <div class="absolute-loading" *ngIf="showLoader">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>
    <as-split [unit]="'percent'">
        <as-split-area [size]="20">
            <div class="icd-code-popup-block">
                <div class="icd-code-popup-heading">Filter</div>
                <div class="icd-code-popup-container">
                    <div class="icd-code-popup-content scrollbar">
                        <div class="filter-block">
                            <div class="filter">
                                <label>Code</label>
                                <input type="text" class="form-control" [(ngModel)]="icdCode" (keyup)="filterICDRecords()" placeholder="Filter by code" />
                            </div>
                            <div class="filter">
                                <label>Text</label>
                                <input type="text" class="form-control" [(ngModel)]="icdText" (keyup)="filterICDRecords()" placeholder="Filter by text" />
                            </div>
                            <div class="filter">
                                <label>Fuzzy Filter</label>
                                <div>
                                    <div class="switch-button" [class.active]="fuzzyFilter" (click)="fnSwitchToggle()"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </as-split-area>
        <as-split-area [size]="40">
            <div class="icd-code-popup-block">
                <div class="icd-code-popup-heading">ICD 10 Codes</div>
                <div class="icd-code-popup-container">
                    <div class="icd-code-popup-content scrollbar">
                        <cdk-virtual-scroll-viewport itemSize="35" class="scrollbar">
                            <div class="icd-code-popup-item" *cdkVirtualFor="let item of filteredCodeList">
                                <div class="checkbox hover" [class.selected]="checkCodeItemSelected(item)" (click)="selectThisCodeItem(item)">
                                    <span></span>
                                </div>
                                <div class="code-text">{{getOptionText(item)}}</div>
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </div>
            </div>
        </as-split-area>
        <as-split-area [size]="40">
            <div class="icd-code-popup-block">
                <div class="icd-code-popup-heading">{{LANGUAGE==LANGUAGE_ENUM.EN?'Selected':'Ausgewählt'}}</div>
                <div class="icd-code-popup-container">
                    <div class="icd-code-popup-content scrollbar">
                        <div style="width:100%;">
                            <div class="icd-code-popup-item selected" *ngFor="let option of selectedOptions;let i=index">
                                <div class="up-down">
                                    <div class="up" (click)="moveItemUp(i)" *ngIf="i>0"></div>
                                    <div class="down" (click)="moveItemDown(i)" *ngIf="i<selectedOptions.length-1"></div>
                                </div>
                                <div class="code-text-icon">
                                    <div class="code-text">{{option.value}}</div>
                                    <div class="remove" (click)="removeItem(i)">&times;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </as-split-area>
    </as-split>
</div>
